import React from "react";
import { PrinterIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { tools } from "../../data/landing";
export function Tools() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-20" data-id="element-262" data-mp="2mhb9f76peaog">
      <div className="mx-auto max-w-3xl" data-id="element-263" data-mp="2higkrom21rwf">
        <h2 className="text-center font-display text-3xl font-extrabold leading-tight sm:text-4xl" data-id="element-264" data-mp="2dipy9x3k9xxp">
          And you'll also get these <em className="italic text-sky" data-id="element-265" data-mp="28jmush38bzru">professional tools</em>
        </h2>

        <ul className="mt-10 divide-y divide-white/10 rounded-3xl bg-navy2 ring-1 ring-white/10" data-id="element-266" data-mp="23swlwtvlhese">
          {tools.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 p-5 sm:p-6" data-id="element-267" data-mp="1yttfb4zyv0ib">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sky/15 text-sky" data-id="element-268" data-mp="1tvi6mxleqw1o">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-269" data-mp="1prk9gsfn7vb9" />
              </span>
              <div data-id="element-270" data-mp="1kuts81s3qto9">
                <h3 className="text-[17px] font-bold leading-snug" data-id="element-271" data-mp="1kuamdjfq7vql">{title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-272" data-mp="158etvf3myayv">{text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mt-6 flex items-center justify-center gap-2 text-center text-[15px] font-semibold text-white/85" data-id="element-273" data-mp="1a20xyivqh6j2">
          <PrinterIcon className="h-4 w-4 text-sky" aria-hidden="true" data-id="element-274" data-mp="10a3iv11ltuf2" />
          Everything is designed to be downloaded, printed and reused.
        </p>
        <div className="mt-10" data-id="element-275" data-mp="1o0qu9waqb26d">
          <CTAButton label="I want the complete system" dark data-id="element-276" data-mp="1sz22k2ldl4mh" />
        </div>
      </div>
    </section>;
}